import { render } from "./CardCompany.vue?vue&type=template&id=dcc12560&scoped=true"
import script from "./CardCompany.vue?vue&type=script&lang=js"
export * from "./CardCompany.vue?vue&type=script&lang=js"

import "./CardCompany.vue?vue&type=style&index=0&id=dcc12560&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc12560"]])

export default __exports__